import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CustomerOrderDetailsService {

  constructor(private http: MyHttpClient) { }
  server = `${environment.server}`;
  getRefund = this.server + '/api/getRefundAmount'; // make this configurable
  getAdjustments = this.server + '/api/payments/getCustomerAdjustments';

  getRefundAmount(orders, id) {
    return this.http.post(this.getRefund + '/' + id, orders).pipe(catchError(this.handleError));
  }
  
  getAdjustmentAmounts(orders, id) {
    return this.http.post(this.getAdjustments + '/' + id, orders).map(res => {
      const details = res['data'] && res['data'].response && res['data'].response.data &&
      res['data'].response.data.list ? res['data'].response.data.list : [];
      return details;
    })
    .pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
